const AUTH_TOKEN = "AUTH_TOKEN";

export function getAuthToken() {
  const authHeader = sessionStorage.getItem(AUTH_TOKEN);
  return authHeader || "";
}

export const setAuthToken = (setSessionToken?: Function): void => {
  const isBrowser = typeof window !== 'undefined';
  if (isBrowser) {
    if (
      window.ikea &&
      window.ikea.authentication &&
      window.ikea.authentication.getTokens
    ) {
      window.ikea.authentication.getTokens((error: string | undefined, tokens: any) => {
          const token = tokens && tokens.auth && tokens.auth.value;
          if (!error && token) {
            sessionStorage.setItem(AUTH_TOKEN, token || "");
            if (setSessionToken) {
              setSessionToken(token);
              console.log('[cl] token: ', token);
            }
          } else {
            sessionStorage.removeItem(AUTH_TOKEN);
            if (setSessionToken) {
              setSessionToken('unknown');
              console.log('[cl] token: unknown');
            }
          }
        }
      );
    }
    console.log('[cl] token: nothing available');
  }
}

export function getInfoFromJwt(jwt: string) {
  const [, payload] = jwt.split(".");

  const jsonPayload: {
    "https://accounts.ikea.com/retailUnit": string;
    "https://accounts.ikea.com/memberId": string;
    "https://accounts.ikea.com/partyUId": string;
  } = JSON.parse(atob(payload));

  return {
    retailUnit: jsonPayload["https://accounts.ikea.com/retailUnit"],
    memberId: jsonPayload["https://accounts.ikea.com/memberId"],
    partyUId: jsonPayload["https://accounts.ikea.com/partyUId"],
  };
}

type UserDataType = {
  customers: {
    partyUId: string;
    firstName: string;
    lastName: string;
    contactMethods: {
      value: string;
      type: string;
    }[];
    loyaltyMemberships: {
      programCode: string;
      status: string;
    }[];
  }[];
};

export function formatUserData(userData: UserDataType) {
  const [customer] = userData.customers;
  const loyalty = customer.loyaltyMemberships.map(
    (program) => program.programCode
  );
  const { partyUId, firstName, lastName, contactMethods } = customer;

  const contact = contactMethods.reduce((acc, item) => {
    if (!["EMAIL", "SMS"].includes(item.type)) {
      return acc;
    }

    return { ...acc, [item.type]: item.value };
  }, {});

  return { loyalty, firstName, lastName, contact, partyUId };
}
